import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useSelector } from 'react-redux';

import type { Visit } from '../@types/visits';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

// Response structure for the recent visits API
export interface RecentVisitsResponse {
  visits: Visit[];
}

export const useGetRecentVisits = (imageTypes: string[]) => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  const path = `${currentPracticeId}/${endpoints.estimatedVisits}`;

  const imageTypesKey = imageTypes.join(',');

  return useQuery<
    RecentVisitsResponse,
    AxiosError<unknown>,
    RecentVisitsResponse,
    [string, string, string, string]
  >(
    [path, currentOrganizationId, currentPracticeId, imageTypesKey],
    async () => {
      const response = await makeAPIRequestReactQuery<RecentVisitsResponse>(
        path,
        { imageTypes },
        'GET',
        {
          headers: { org: currentOrganizationId, practice: currentPracticeId },
        },
      );
      return response;
    },
    {
      enabled: !!currentOrganizationId && !!currentPracticeId,
    },
  );
};
